/**
 * Generates a random number in ]0; 1[ range.
 * Use this instead of `Math.random()` since it is insecure.
 * @returns {number} A number in ]0; 1[ range.
 */
export function generateRandomNumberBetween0and1(): number {
	return crypto.getRandomValues(new Uint32Array(1))[0] / (2 ** 32 - 1);
}

/**
 * Generates a random number in ]min; max[ range.
 * Use this instead of `Math.random()` since it is insecure.
 * @param {number} min Minimum value.
 * @param {number} max Maximum value.
 * @returns {number} A random number in ]min; max[ range.
 */
export function generateRandomNumberBetween(min: number, max: number): number {
	const number = generateRandomNumberBetween0and1();
	return Math.floor(number * (max - min + 1) + min);
}
